"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.VideoPlayerUiMethod=void 0;var e;(function(t){t.ButtonTap="button_tap",t.TitleTap="title_tap",t.VideoTap="video_tap"})(e||(exports.VideoPlayerUiMethod=e={}));
//# sourceMappingURL=VideoPlayerUiMethod.js.map
